// AbTrendChart — 7-Tage-Trend als reine CSS-Balken, zwei Serien (Eingang/uebertragen).
// Muster: components/lager/dashboard/BestandsverlaufChart.js (keine Chart-Bibliothek).

import React from 'react';
import { Card, SectionTitle } from '../ui';

const AbTrendChart = ({ trend, isDarkMode, t }) => {
  const data = Array.isArray(trend) ? trend : [];
  const textMuted = isDarkMode ? 'text-white/40' : 'text-slate-400';

  const legend = (
    <span className={`flex items-center gap-3 text-[11px] ${textMuted}`}>
      <span className="flex items-center gap-1"><span className={`w-2 h-2 rounded-sm ${isDarkMode ? 'bg-blue-400' : 'bg-blue-500'}`} />{t('ab.shell.trendReceived')}</span>
      <span className="flex items-center gap-1"><span className={`w-2 h-2 rounded-sm ${isDarkMode ? 'bg-emerald-400' : 'bg-emerald-500'}`} />{t('ab.shell.trendTransferred')}</span>
    </span>
  );

  if (data.length === 0) {
    return (
      <Card isDarkMode={isDarkMode}>
        <SectionTitle isDarkMode={isDarkMode} right={legend}>{t('ab.shell.trendTitle')}</SectionTitle>
        <p className={`text-sm ${textMuted}`}>{t('ab.shell.trendEmpty')}</p>
      </Card>
    );
  }

  const max = Math.max(1, ...data.flatMap((d) => [d.received || 0, d.transferred || 0]));
  const BAR_HEIGHT = 96;

  return (
    <Card isDarkMode={isDarkMode}>
      <SectionTitle isDarkMode={isDarkMode} right={legend}>{t('ab.shell.trendTitle')}</SectionTitle>
      <div className="flex items-end gap-2" style={{ minHeight: BAR_HEIGHT + 24 }}>
        {data.map((d) => {
          const recH = Math.max(Math.round(((d.received || 0) / max) * BAR_HEIGHT), (d.received || 0) > 0 ? 3 : 0);
          const trfH = Math.max(Math.round(((d.transferred || 0) / max) * BAR_HEIGHT), (d.transferred || 0) > 0 ? 3 : 0);
          const weekday = new Date(`${d.date}T00:00:00`).toLocaleDateString('de-DE', { weekday: 'short' });
          return (
            <div key={d.date} className="flex flex-col items-center flex-1 min-w-0">
              <div className="flex items-end gap-0.5" style={{ height: BAR_HEIGHT }} title={`${weekday}: ${d.received || 0} ${t('ab.shell.trendReceived')} · ${d.transferred || 0} ${t('ab.shell.trendTransferred')}`}>
                <div className={`w-2.5 rounded-t-sm ${isDarkMode ? 'bg-blue-400/80' : 'bg-blue-500'}`} style={{ height: recH }} />
                <div className={`w-2.5 rounded-t-sm ${isDarkMode ? 'bg-emerald-400/80' : 'bg-emerald-500'}`} style={{ height: trfH }} />
              </div>
              <span className={`text-[10px] mt-1 ${textMuted}`}>{weekday}</span>
            </div>
          );
        })}
      </div>
    </Card>
  );
};

export default AbTrendChart;
